// extracted by mini-css-extract-plugin
export default {"avatar":"apoq_3jAlOACY32zPPso","initials":"aBMQsdxN8YXZ4kBnGFGj","size-md":"wh9mJdJcLuOmHWSPB97c","size-lg":"hIErgDF_CYYP_8D2Aglb"};